import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-grids";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { GetScheduleBo } from "./schedule.modal";
@Injectable({
  providedIn: "root",
})
export class ScheduleService extends Subject<DataStateChangeEventArgs> {
  assignChildData: any = [];
  constructor(
    private http: HttpClient,
    public errorService: ErrorService,
    public datePipe: DatePipe
  ) {
    super();
  }
  public execute(SS: GetScheduleBo): void {
    this.getScheduleList(SS).subscribe((x) => super.next(x));
  }
  getScheduleList(SS?: GetScheduleBo): Observable<DataStateChangeEventArgs> {
    return this.http
      .post<any>("api/VisitSchedule/GetScheduleLists", SS)
      .pipe(
        map((response: any) => ({
          result: response["result"],
          count: response["count"],
        }))
      )
      .pipe(
        map((sc: any) => {
          sc.result = JSON.parse(JSON.stringify(this.SetChilddata(sc)));
          return sc;
        })
      );
  }
  SetChilddata(response) {
    let ScheduleParentList = [];
    let ScheduleChildList = [];
    let a: any;
    let b: any;
    if (response.result.length != 0) {
      response.result.forEach((Parentresponse) => {
        let parentData = {
          id: Parentresponse.id,
          clientName: Parentresponse.clientName,
          clientId: Parentresponse.clientId,
          employeeId: Parentresponse.employeeId,
          serviceGroupId: Parentresponse.serviceGroupId,
          employeeName: Parentresponse.employeeName,
          customFrequencyLid: Parentresponse.customFrequencyLid,
          serviceDate: this.datePipe.transform(
            Parentresponse.serviceDate,
            "MM/dd/yyyy"
          ),
          serviceId: Parentresponse.serviceId,
          serviceGroupName: Parentresponse.serviceGroupName,
          serviceName: Parentresponse.serviceName,
          startDate: this.datePipe.transform(
            Parentresponse.startDate,
            "MM/dd/yyyy"
          ),
          endDate: this.datePipe.transform(
            Parentresponse.endDate,
            "MM/dd/yyyy"
          ),
          totalhours: Parentresponse.totalhours,
          frequencyDays: Parentresponse.frequencyDays,
          scheduleWeekDays: Parentresponse.scheduleWeekDays,
          visitScheduleId: Parentresponse.id,
          appointmentDate: this.datePipe.transform(
            Parentresponse.appointments[0]?.appointmentDate,
            "MM/dd/yyyy"
          ),
          startTime:
            Parentresponse.startDate != null
              ? this.datePipe.transform(Parentresponse.startDate, "HH:mm")
              : null,
          endTime: Parentresponse.endDate
            ? this.datePipe.transform(Parentresponse.endDate, "HH:mm")
            : null,

          setstartTime:
            Parentresponse.startDate != null
              ? this.datePipe.transform(Parentresponse.startDate, "hh:mm a")
              : null,
          setendTime: Parentresponse.endDate
            ? this.datePipe.transform(Parentresponse.endDate, "hh:mm a")
            : null,          
        };
        ScheduleParentList.push(parentData);
        Parentresponse.appointments.forEach((element) => {
          let childData = {
            frequencyDays: Parentresponse.frequencyDays,
            clientName: Parentresponse.clientName,
            employeeName: Parentresponse.employeeName,
            serviceGroupName: Parentresponse.serviceGroupName,
            startDate: this.datePipe.transform(
              Parentresponse.startDate,
              "MM/dd/yyyy"
            ),
            endDate: this.datePipe.transform(
              Parentresponse.endDate,
              "MM/dd/yyyy"
            ),
            visitScheduleId: element.visitScheduleId,
            customFrequencyLid: Parentresponse.customFrequencyLid,
            isViststarted:
              element.isVisitCancelled == true
                ? "Cancelled"
                : element.isVisitstarted == false &&
                  element.isVisitMissed == false
                ? "Not yet started"
                : element.isVisitstarted == true && element.isVisitCompleted == false
                ? "Started": element.isVisitCompleted == true &&element.isVisitstarted == true ?
                "Completed"
                : "Missed",
            hours: element.hours,
            appointmentId: element.appointmentId,
            appointmentDay: element.appointmentDay,
            appointmentDate: this.datePipe.transform(
              element.appointmentDate,
              "MM/dd/yyyy"
            ),
            clientId: Parentresponse.clientId,
            employeeId: Parentresponse.employeeId,
            serviceGroupId: Parentresponse.serviceGroupId,
            scheduleWeekDays: Parentresponse.scheduleWeekDays,
            startTime:
              element.startTime != null
                ? this.datePipe.transform(element.startTime, "HH:mm")
                : null,
            endTime:
              element.endTime != null
                ? this.datePipe.transform(element.endTime, "HH:mm")
                : null,
            setstartTime:
              element.startTime != null
                ? this.datePipe.transform(element.startTime, "hh:mm a")
                : null,
            setendTime:
              element.endTime != null
                ? this.datePipe.transform(element.endTime, "hh:mm a")
                : null,
          };
          ScheduleChildList.push(childData);
        });

        this.assignChildData = ScheduleChildList;
      });
    } else {
      ScheduleParentList = [];
    }
    return ScheduleParentList;
  }
  getChildGridList() {
    return this.assignChildData;
  }
}

